<script>
  export let isIso = true;
</script>

<style>
  div.svg-container {
    position: relative;
    top: -110px;
    left: 180px;
    opacity: 0;
    transition: 0.5s opacity;
  }

  svg {
    position: absolute;
    top: 105px;
    left: 0;
    width: 60px;
  }

  div.svg-container.isIso {
    opacity: 1;
  }
</style>

<div class:isIso class="svg-container">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 69.97 98.76">
    <defs>
      <style>
        .cl-1 {
          fill: #cc4e5c;
        }
        .cl-1,
        .cl-2,
        .cl-3 {
          stroke: #000;
          stroke-miterlimit: 10;
        }
        .cl-2,
        .cl-4 {
          fill: #fff;
        }
        .cl-3 {
          fill: #bcaab3;
        }
      </style>
    </defs>
    <g id="Layer_2" data-name="Layer 2">
      <g id="Layer_2-2" data-name="Layer 2">
        <polygon
          class="cl-1"
          points="32.16 98.2 37.06 95.69 69.16 79.2 69.16 33.2 32.16 52.2 3.16
          40.2 3.16 83.2 32.16 98.2" />
        <line class="cl-2" x1="31.31" y1="53.72" x2="31.63" y2="98.5" />
        <polygon
          class="cl-2"
          points="12.68 87.84 6.67 84.84 6.49 68.93 12.5 71.93 12.68 87.84" />
        <polygon
          class="cl-2"
          points="15.06 60.8 5.06 55.67 5.06 46.67 15.06 51.8 15.06 60.8" />
        <polyline class="cl-1" points="69.05 36 50.18 17.37 31.33 54.02" />
        <polygon
          class="cl-3"
          points="31.48 53.74 0.66 38.7 18.73 0.69 49.37 16.79 31.48 53.74" />
        <polygon
          class="cl-2"
          points="28.25 67.68 18.25 62.55 18.25 53.55 28.25 58.68 28.25 67.68" />
        <polygon
          class="cl-2"
          points="27.98 88.06 17.98 82.92 17.98 73.92 27.98 79.06 27.98 88.06" />
        <polygon
          class="cl-4"
          points="66.5 32.75 71 36.98 73.71 31.93 68.5 31.7" />
      </g>
    </g>
  </svg>
</div>
